interface FilterSidebarProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  selectedSizes: string[];
  setSelectedSizes: (sizes: string[]) => void;
  priceRange: [number, number];
  setPriceRange: (range: [number, number]) => void;
}

export default function FilterSidebar({
  selectedCategory,
  setSelectedCategory,
  selectedSizes,
  setSelectedSizes,
  priceRange,
  setPriceRange,
}: FilterSidebarProps) {
  const categories = [
    { id: 'all', label: 'All Products' },
    { id: 'apparel', label: 'Apparel' },
    { id: 'footwear', label: 'Footwear' },
    { id: 'accessories', label: 'Accessories' },
  ];

  const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

  const handleSizeToggle = (size: string) => {
    if (selectedSizes.includes(size)) {
      setSelectedSizes(selectedSizes.filter((s) => s !== size));
    } else {
      setSelectedSizes([...selectedSizes, size]);
    }
  };

  const clearFilters = () => {
    setSelectedCategory('all');
    setSelectedSizes([]);
    setPriceRange([0, 500]);
  };

  return (
    <div className="space-y-8">
      {/* Clear Filters */}
      <button
        onClick={clearFilters}
        className="text-sm font-bold text-gray-400 hover:text-white transition-colors whitespace-nowrap"
      >
        <i className="ri-refresh-line mr-2"></i>
        CLEAR ALL FILTERS
      </button>

      {/* Category Filter */}
      <div>
        <h3 className="text-sm font-black tracking-[0.15em] text-white mb-4 uppercase">
          Category
        </h3>
        <div className="space-y-2">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`w-full text-left px-4 py-3 rounded-lg text-sm font-bold transition-all whitespace-nowrap ${
                selectedCategory === category.id
                  ? 'bg-white text-black'
                  : 'bg-[#1A1A1A] text-gray-400 hover:text-white hover:bg-white/5'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>
      </div>

      {/* Size Filter */}
      <div>
        <h3 className="text-sm font-black tracking-[0.15em] text-white mb-4 uppercase">
          Size
        </h3>
        <div className="grid grid-cols-3 gap-2">
          {sizes.map((size) => (
            <button
              key={size}
              onClick={() => handleSizeToggle(size)}
              className={`py-3 rounded-lg text-sm font-bold transition-all whitespace-nowrap ${
                selectedSizes.includes(size)
                  ? 'bg-white text-black'
                  : 'bg-[#1A1A1A] text-gray-400 hover:text-white hover:bg-white/5'
              }`}
            >
              {size}
            </button>
          ))}
        </div>
      </div>

      {/* Price Range Filter */}
      <div>
        <h3 className="text-sm font-black tracking-[0.15em] text-white mb-4 uppercase">
          Price Range
        </h3>
        <div className="space-y-4">
          <input
            type="range"
            min="0"
            max="500"
            step="10"
            value={priceRange[1]}
            onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
            className="w-full h-2 bg-[#1A1A1A] rounded-lg appearance-none cursor-pointer accent-white"
          />
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-400 font-medium">$0</span>
            <span className="text-white font-bold">${priceRange[1]}</span>
          </div>
        </div>
      </div>

      {/* Quick Filters */}
      <div>
        <h3 className="text-sm font-black tracking-[0.15em] text-white mb-4 uppercase">
          Quick Filters
        </h3>
        <div className="space-y-2">
          <button className="w-full text-left px-4 py-3 rounded-lg text-sm font-bold bg-[#1A1A1A] text-gray-400 hover:text-white hover:bg-white/5 transition-all whitespace-nowrap">
            On Sale
          </button>
          <button className="w-full text-left px-4 py-3 rounded-lg text-sm font-bold bg-[#1A1A1A] text-gray-400 hover:text-white hover:bg-white/5 transition-all whitespace-nowrap">
            Best Sellers
          </button>
          <button className="w-full text-left px-4 py-3 rounded-lg text-sm font-bold bg-[#1A1A1A] text-gray-400 hover:text-white hover:bg-white/5 transition-all whitespace-nowrap">
            Limited Edition
          </button>
        </div>
      </div>
    </div>
  );
}